var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24PaperPlane = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "3 0 26 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.995 17.21l2.187-4.375h6.562l-8.749 4.374zm8.75-6.042h-6.563l-2.187-4.374 8.75 4.374zm4.143 1.386c.052-.057.095-.12.128-.19.012-.024.023-.048.033-.074.035-.092.058-.187.058-.288 0-.102-.023-.197-.059-.29-.009-.024-.02-.048-.032-.072-.034-.07-.077-.135-.13-.194-.012-.014-.021-.028-.035-.042-.06-.058-.127-.109-.204-.148L9.505 4.186c-.322-.161-.709-.099-.962.155-.254.254-.318.641-.157.963l3.35 6.698-3.35 6.699c-.16.32-.097.707.157.96.253.255.64.317.96.157l14.143-7.071c.077-.04.145-.09.204-.148.015-.013.024-.03.038-.045z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24PaperPlane, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_ paper-plane.55beffe5.svg";
export { ForwardRef as ReactComponent };